import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import type { PlayerProfileFormProps } from './types';
import { asNumber, asString, setNumber, setString } from './helpers';

export const RacketPlayerProfileForm: React.FC<PlayerProfileFormProps> = ({ value, onChange }) => (
  <Box sx={{ display: 'grid', gap: 1.5, gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' } }}>
    <FormControl fullWidth size="small">
      <InputLabel>Рабочая рука</InputLabel>
      <Select
        value={asString(value.hand)}
        label="Рабочая рука"
        onChange={(e) => setString(value, 'hand', e.target.value, onChange)}
      >
        <MenuItem value="left">Левая</MenuItem>
        <MenuItem value="right">Правая</MenuItem>
      </Select>
    </FormControl>
    <FormControl fullWidth size="small">
      <InputLabel>Бэкхенд</InputLabel>
      <Select
        value={asString(value.backhand)}
        label="Бэкхенд"
        onChange={(e) => setString(value, 'backhand', e.target.value, onChange)}
      >
        <MenuItem value="one_handed">Одноручный</MenuItem>
        <MenuItem value="two_handed">Двуручный</MenuItem>
      </Select>
    </FormControl>
    <TextField label="Рейтинг" size="small" value={asNumber(value.rating)} onChange={(e) => setNumber(value, 'rating', e.target.value, onChange)} />
    <TextField label="Сильная сторона" size="small" value={asString(value.style)} onChange={(e) => setString(value, 'style', e.target.value, onChange)} />
  </Box>
);
